/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { useLazyObtenerArchivoQuery } from "src/redux/api/documentosSoporteApi";
import { Box, CircularProgress } from "@mui/material";

interface PDFViewerProps {
  pdfFile?: string;
}

const VisorPdf = ({ pdfFile }: PDFViewerProps) => {
  const [obtenerAdjunto, { isLoading: descargandoArchivo }] =
    useLazyObtenerArchivoQuery();
  const [pdfUrls, setPdfUrls] = useState<string>();
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  useEffect(() => {
    if (pdfFile) {
      obtenerAdjunto({ adjuntoId: pdfFile })
        .unwrap()
        .then((resp) => {
          const objectUrl = window.URL.createObjectURL(resp);
          setPdfUrls(objectUrl);
        });
    }
  }, [pdfFile]);

  if (descargandoArchivo) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress color="primary" size={40} sx={{ mt: 5 }} />;
      </Box>
    );
  }

  if (!pdfUrls || !pdfFile) {
    return <div>No se encontró el PDF</div>;
  }

  return (
    <div style={{ height: "750px", border: "1px solid #ddd" }}>
      {/* Componente Viewer para renderizar el PDF */}
      <Worker
        workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}
      >
        <Viewer fileUrl={pdfUrls} plugins={[defaultLayoutPluginInstance]} />
      </Worker>
    </div>
  );
};

export default VisorPdf;
